import { isEmpty } from "@hints/utils/data";

export function formatName(...segments: string[]) {
    return segments.filter(s => !isEmpty(s)).join(' ');
}